import { type FC, type ComponentProps, type ReactNode } from "react";
import { FormattedHTMLMessage } from "react-intl";

import { BenefitIcon } from "../BenefitIcon/BenefitIcon";

import styles from "./ProBenefits.module.scss";

export const ProBenefits: FC = () => {
  return (
    <section className={styles.container}>
      <ul className={styles.benefits}>
        {benefits.map((benefit, index) => (
          <li className={styles.card} key={index}>
            <BenefitIcon icon={benefit.icon} />
            <div className={styles.description}>{benefit.description}</div>
          </li>
        ))}
      </ul>
    </section>
  );
};

const benefits: Array<{
  icon: ComponentProps<typeof BenefitIcon>["icon"];
  description: ReactNode;
}> = [
  {
    icon: "Certificate",
    description: (
      <p>
        <FormattedHTMLMessage id="certifiedPage.proBenefits.accredited" />
      </p>
    ),
  },
  {
    icon: "TwentyYears",
    description: (
      <p>
        <FormattedHTMLMessage id="certifiedPage.proBenefits.rights" />
      </p>
    ),
  },
  {
    icon: "Website",
    description: (
      <p>
        <FormattedHTMLMessage
          id="certifiedPage.proBenefits.referrals"
          values={{
            url: "https://www.chemelex.com/raychem/solutions/commercial/floor-heating",
          }}
        />
      </p>
    ),
  },
  {
    icon: "Promotions",
    description: (
      <p>
        <FormattedHTMLMessage id="certifiedPage.proBenefits.promotions" />
      </p>
    ),
  },
  {
    icon: "Events",
    description: (
      <p>
        <FormattedHTMLMessage id="certifiedPage.proBenefits.events" />
      </p>
    ),
  },
];
